import PropertyDetailsModal from '../../PropertyDetailsModal';

type Props = {
  isOpen: boolean;
  floorPlanId: string;
  initialBeds?: number | null;
  initialBaths?: number | null;
  isStreetEasyRestricted?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const PropertyDetailsStep = ({
  isOpen,
  floorPlanId,
  initialBeds,
  initialBaths,
  isStreetEasyRestricted = false,
  onClose,
  onConfirm,
}: Props): JSX.Element => {
  return (
    <PropertyDetailsModal
      isOpen={isOpen}
      floorPlanId={floorPlanId}
      initialBeds={initialBeds}
      initialBaths={initialBaths}
      isStreetEasyRestricted={isStreetEasyRestricted}
      onClose={onClose}
      onConfirm={onConfirm}
      submitLabel="Continue"
    />
  );
};

export default PropertyDetailsStep;
